{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Перейти на Pro",
    "navBilling": "Оплата"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Ваша вкладка. Ваш <em>зикр</em>.<br />На новом уровне.",
    "subtitle": "Всё необходимое для более осознанного дня — от времён молитв и размышления над аятами с AI до погоды и приоритетных задач — в одной спокойной и красивой новой вкладке.",
    "comparison_aria": "Сравнение планов",
    "free": {
      "tierLabel": "Текущий",
      "tierName": "Free",
      "freeLabel": "Всегда бесплатно",
      "list_aria": "Возможности бесплатного плана"
    },
    "pro": {
      "list_aria": "Возможности плана Pro",
      "tierLabel": "Перейти на",
      "tierName": "Pro",
      "pricePeriod": "/ месяц",
      "priceAlt": "или $39.99 / год"
    },
    "freeFeatures": {
      "clockDate": "Часы и дата",
      "verseOfDay": "Аят дня из Корана",
      "dailyBackground": "Ежедневное фоновое фото",
      "qiblaCompass": "Компас Qibla",
      "basicTasks": "Базовые задачи"
    },
    "proFeatures": {
      "weatherForecast": "Прогноз погоды на 5 дней",
      "verseFavorites": "Сохранение и просмотр избранных аятов",
      "notesAi": "Заметки с анализом AI",
      "priorityTasks": "Управление приоритетными задачами",
      "verseReflection": "Размышление над аятом с AI"
    },
    "plans": {
      "monthly": {
        "label": "Помесячно",
        "price": "$4.99",
        "period": "/ месяц",
        "note": "Оплата ежемесячно"
      },
      "yearly": {
        "label": "Ежегодно",
        "price": "$39.99",
        "period": "/ год",
        "note": "Два месяца бесплатно",
        "badge": "Экономия 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Отмена в любое время. Доступ сохраняется до конца оплаченного периода без частичных списаний.",
    "billingPeriod_aria": "Период оплаты",
    "cta": "Перейти к безопасной оплате",
    "ctaLoading": "Переход к оплате…",
    "promoManual": "Введите код {{code}} на следующей странице, чтобы получить скидку.",
    "signingUpAs": "Оформление для {{account}}",
    "trustSignals_aria": "Гарантии",
    "reassurance": {
      "secureCheckout": "Безопасная оплата через Stripe",
      "cancelAnytime": "Отмена в любое время, без вопросов",
      "accessUntilEnd": "Доступ до конца периода"
    },
    "errors": {
      "restoreSession": "Не удалось восстановить сессию. Попробуйте снова из расширения.",
      "checkoutFailed": "Не удалось начать оплату. Попробуйте снова."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Открытые возможности",
    "unlockedFeatures": {
      "weatherForecast": "Прогноз погоды на 5 дней",
      "verseFavorites": "Сохранение и просмотр избранных аятов",
      "notesAi": "Заметки с анализом AI",
      "priorityTasks": "Управление приоритетными задачами",
      "verseReflection": "Размышление над аятом с AI"
    },
    "success": {
      "title": "Добро пожаловать в Pro",
      "desc": "Ваша подписка активна. Вернитесь в расширение — все возможности Pro уже ждут вас.",
      "viewBilling": "Посмотреть детали оплаты",
      "closeTab": "Закрыть эту вкладку"
    },
    "cancel": {
      "title": "Оплата отменена",
      "desc": "Ничего страшного — ваш план не изменился, и средства не списаны. Вы можете перейти на Pro, когда будете готовы.",
      "backToUpgrade": "Назад к переходу на Pro",
      "returnToExtension": "Вернуться в расширение"
    }
  },
  "billing": {
    "title": "Оплата",
    "subtitle": "Управляйте подпиской и просматривайте историю платежей.",
    "subscription_aria": "Статус подписки",
    "subscriptionTitle": "Подписка",
    "loading_aria": "Загрузка информации об оплате",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "Активна",
      "trialing": "Пробный период",
      "past_due": "Просрочена",
      "unpaid": "Не оплачена",
      "canceled": "Отменена",
      "incomplete": "Не завершена",
      "none": "Нет подписки"
    },
    "planValues": {
      "proYearly": "Pro · Ежегодно",
      "proMonthly": "Pro · Помесячно"
    },
    "warnings": {
      "paymentFailedTitle": "Платёж не прошёл",
      "paymentFailedDesc": "Ваш последний платёж не прошёл. Обновите способ оплаты в разделе «Управление оплатой», чтобы сохранить доступ к Pro.",
      "trialEndingTitle": "Пробный период скоро завершится",
      "trialEndingToday": "Ваш пробный период заканчивается сегодня, {{date}}. Добавьте способ оплаты, чтобы сохранить возможности Pro.",
      "trialEndingInDays_one": "Ваш пробный период заканчивается через {{count}} день, {{date}}. Добавьте способ оплаты, чтобы сохранить возможности Pro.",
      "trialEndingInDays_other": "Ваш пробный период заканчивается через {{count}} дней, {{date}}. Добавьте способ оплаты, чтобы сохранить возможности Pro."
    },
    "cancellationScheduled": "Отмена запланирована. Полный доступ к Pro сохраняется до <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "Пробный период заканчивается сегодня",
      "trialDaysRemaining_one": "Осталось {{count}} день пробного периода",
      "trialDaysRemaining_other": "Осталось {{count}} дней пробного периода",
      "renews": "Продление {{date}}",
      "accessUntil": "Доступ до {{date}}"
    },
    "kv": {
      "status": "Статус",
      "nextRenewal": "Следующее продление",
      "trialEnds": "Конец пробного периода",
      "trialDaysLeft_one": "Остался {{count}} день",
      "trialDaysLeft_other": "Осталось {{count}} дней",
      "endsToday": "заканчивается сегодня",
      "plan": "План"
    },
    "upgradeNudge": {
      "title": "Откройте возможности Pro",
      "desc": "Погода, времена молитв, размышление над аятами с AI и многое другое — $4.99/месяц или $39.99/год.",
      "cta": "Перейти на Pro"
    },
    "actions": {
      "manageBilling": "Управление оплатой и способом оплаты",
      "cancelConfirmTitle": "Отменить подписку?",
      "cancelConfirmDesc": "Вы сохраните полный доступ к Pro до конца текущего оплаченного периода. Частичные возвраты не предоставляются.",
      "canceling": "Отмена…",
      "yesCancel": "Да, отменить",
      "keepPro": "Оставить Pro",
      "cancelSubscription": "Отменить подписку"
    },
    "noSubscription": "Подписка не найдена.",
    "paymentHistory_aria": "История платежей",
    "paymentHistoryTitle": "История платежей",
    "invoices_aria": "Счета",
    "invoiceView": "Посмотреть",
    "invoiceView_aria": "Посмотреть счёт от {{date}}",
    "noInvoices": "Счетов пока нет.",
    "dangerZone_aria": "Опасная зона",
    "dangerZoneTitle": "Опасная зона",
    "deleteAccountTitle": "Удалить аккаунт",
    "deleteAccountDesc": "Безвозвратно удалить ваш аккаунт и все связанные данные — задачи, заметки, избранное и историю платежей. Это действие нельзя отменить.",
    "deleteAccountBtn": "Удалить аккаунт",
    "deleteConfirm": {
      "warning": "Это немедленно и безвозвратно:",
      "list": {
        "deleteContent": "Удалит все ваши задачи, заметки и избранные аяты",
        "cancelSubscription": "Отменит любую активную подписку (без возврата за неиспользованное время)",
        "removeAccount": "Удалит ваш аккаунт из нашей базы данных",
        "signOut": "Выйдет из аккаунта на всех устройствах"
      },
      "typeToConfirm": "Введите <strong>DELETE</strong> для подтверждения",
      "inputPlaceholder": "DELETE",
      "deleting": "Удаление…",
      "confirmBtn": "Безвозвратно удалить мой аккаунт",
      "cancelBtn": "Отмена"
    },
    "errors": {
      "loadFailed": "Не удалось загрузить информацию об оплате.",
      "cancelFailed": "Не удалось отменить подписку.",
      "deleteFailed": "Не удалось удалить аккаунт. Попробуйте снова или обратитесь в поддержку.",
      "portalFailed": "Не удалось открыть портал оплаты."
    }
  },
  "privacy": {
    "tocLabel": "Политика конфиденциальности",
    "toc_aria": "Содержание",
    "lastUpdated": "Последнее обновление<br />22 сентября 2026 г.",
    "sections": {
      "overview": "Обзор",
      "informationWeCollect": "Какие данные мы собираем",
      "connectedServices": "Подключённые сервисы (Google, Todoist, Apple)",
      "howWeUse": "Как мы используем ваши данные",
      "howWeShare": "Как мы передаём ваши данные",
      "dataRetention": "Хранение данных",
      "yourRights": "Ваши права на конфиденциальность",
      "california": "Жители Калифорнии (CCPA/CPRA)",
      "cookies": "Cookie и локальное хранилище",
      "security": "Безопасность данных",
      "changes": "Изменения этой политики",
      "contact": "Связаться с нами"
    },
    "headings": {
      "informationWeCollect": "Какие данные мы собираем",
      "connectedServices": "Подключённые сервисы (Google, Todoist, Apple)",
      "howWeUse": "Как мы используем ваши данные",
      "howWeShare": "Как мы передаём ваши данные",
      "dataRetention": "Хранение данных",
      "yourRights": "Ваши права на конфиденциальность",
      "california": "Жители Калифорнии (CCPA / CPRA)",
      "cookies": "Cookie и локальное хранилище",
      "security": "Безопасность данных",
      "changes": "Изменения этой политики",
      "contact": "Связаться с нами"
    }
  },
  "deleteAccount": {
    "intro": "Удаление аккаунта безвозвратно удалит:",
    "list": {
      "account": "Ваш аккаунт и профиль",
      "tasks": "Все задачи",
      "notes": "Все заметки",
      "verses": "Сохранённые аяты",
      "billing": "Данные о подписке"
    },
    "irreversible": "Это действие нельзя отменить.",
    "appleNotice": "Удаление аккаунта не отменяет подписку, оформленную через App Store. Пожалуйста, отмените её также в Настройках → Apple ID → Подписки.",
    "manageSubscription": "Управление подпиской",
    "continueBtn": "Продолжить удаление",
    "keepBtn": "Сохранить аккаунт",
    "confirmTitle": "Удалить аккаунт?",
    "confirmDesc": "Ваш аккаунт и все его данные будут удалены безвозвратно. Это действие нельзя отменить.",
    "confirmBtn": "Безвозвратно удалить мой аккаунт",
    "deleting": "Удаление…",
    "error": "Не удалось удалить аккаунт. Проверьте подключение и попробуйте ещё раз."
  }
}
